import http from "../http-common";

const route = "system"

class SystemService {
  app_login(data) {
    return http().post(`/${route}/app_login`, data);
  }

  app_signin(data) {
    return http().post(`/${route}/app_signin`, data);
  }

  app_remember(data) {
    return http().post(`/${route}/app_remember`, data);
  }

  app_reset(data) {
    return http().post(`/${route}/app_reset`, data);
  }

}

export default new SystemService();